import "./es.array.iterator.js";
import { _ as e } from "../internals/export.js";
import { g as t } from "../internals/global.js";
import { f as r } from "../internals/function-call.js";
import { f as n } from "../internals/function-uncurry-this.js";
import { d as i } from "../internals/descriptors.js";
import { u as s } from "../internals/url-constructor-detection.js";
import { d as o } from "../internals/define-built-in.js";
import { d as a } from "../internals/define-built-in-accessor.js";
import { d as l } from "../internals/define-built-ins.js";
import { s as u } from "../internals/set-to-string-tag.js";
import { i as f } from "../internals/iterator-create-constructor.js";
import { i as c } from "../internals/internal-state.js";
import { a as h } from "../internals/an-instance.js";
import { i as p } from "../internals/is-callable.js";
import { h as m } from "../internals/has-own-property.js";
import { f as v } from "../internals/function-bind-context.js";
import { c as d } from "../internals/classof.js";
import { a as g } from "../internals/an-object.js";
import { i as y } from "../internals/is-object.js";
import { t as j } from "../internals/to-string.js";
import { o as b } from "../internals/object-create.js";
import { c as k } from "../internals/create-property-descriptor.js";
import { g as w } from "../internals/get-iterator.js";
import { g as R } from "../internals/get-iterator-method.js";
import { v as U } from "../internals/validate-arguments-length.js";
import { w as x } from "../internals/well-known-symbol.js";
import { a as L } from "../internals/array-sort.js";
var S = x("iterator"),
  z = "URLSearchParams",
  E = z + "Iterator",
  P = c.set,
  q = c.getterFor(z),
  C = c.getterFor(E),
  I = Object.getOwnPropertyDescriptor,
  O = function O(e) {
    if (!i) return t[e];
    var r = I(t, e);
    return r && r.value;
  },
  F = O("fetch"),
  Q = O("Request"),
  _ = O("Headers"),
  A = Q && Q.prototype,
  G = _ && _.prototype,
  T = t.RegExp,
  D = t.TypeError,
  H = t.decodeURIComponent,
  B = t.encodeURIComponent,
  J = n("".charAt),
  K = n([].join),
  M = n([].push),
  N = n("".replace),
  V = n([].shift),
  W = n([].splice),
  X = n("".split),
  Y = n("".slice),
  Z = /\+/g,
  $ = [,,,,],
  ee = function ee(e) {
    try {
      return H(e);
    } catch (t) {
      return e;
    }
  },
  et = function et(e) {
    var t,
      r = N(e, Z, " "),
      n = 4;
    try {
      return H(r);
    } catch (e) {
      for (; n;) r = N(r, $[(t = n--) - 1] || ($[t - 1] = T("((?:%[\\da-f]{2}){" + t + "})", "gi")), ee);
      return r;
    }
  },
  er = /[!'()~]|%20/g,
  en = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  },
  ei = function ei(e) {
    return en[e];
  },
  es = function es(e) {
    return N(B(e), er, ei);
  },
  eo = f(function (e, t) {
    P(this, {
      type: E,
      iterator: w(q(e).entries),
      kind: t
    });
  }, "Iterator", function () {
    var e = C(this),
      t = e.kind,
      r = e.iterator.next(),
      n = r.value;
    return r.done || (r.value = "keys" === t ? n.key : "values" === t ? n.value : [n.key, n.value]), r;
  }, !0),
  ea = function ea(e) {
    this.entries = [], this.url = null, void 0 !== e && (y(e) ? this.parseObject(e) : this.parseQuery("string" == typeof e ? "?" === J(e, 0) ? Y(e, 1) : e : j(e)));
  };
ea.prototype = {
  type: z,
  bindURL: function bindURL(e) {
    this.url = e, this.update();
  },
  parseObject: function parseObject(e) {
    var t,
      n,
      i,
      s,
      o,
      a,
      l,
      u = R(e);
    if (u) for (n = (t = w(e, u)).next; !(i = r(n, t)).done;) {
      if ((a = r(o = (s = w(g(i.value))).next, s)).done || (l = r(o, s)).done || !r(o, s).done) throw D("Expected sequence with length 2");
      M(this.entries, {
        key: j(a.value),
        value: j(l.value)
      });
    } else for (var f in e) m(e, f) && M(this.entries, {
      key: f,
      value: j(e[f])
    });
  },
  parseQuery: function parseQuery(e) {
    if (e) for (var t, r, n = X(e, "&"), i = 0; i < n.length;) (t = n[i++]).length && (r = X(t, "="), M(this.entries, {
      key: et(V(r)),
      value: et(K(r, "="))
    }));
  },
  serialize: function serialize() {
    for (var e, t = this.entries, r = [], n = 0; n < t.length;) M(r, es((e = t[n++]).key) + "=" + es(e.value));
    return K(r, "&");
  },
  update: function update() {
    this.entries.length = 0, this.parseQuery(this.url.query);
  },
  updateURL: function updateURL() {
    this.url && this.url.update();
  }
};
var el = function el() {
    h(this, eu);
    var e = arguments.length > 0 ? arguments[0] : void 0,
      t = P(this, new ea(e));
    i || (this.size = t.entries.length);
  },
  eu = el.prototype;
if (l(eu, {
  append: function append(e, t) {
    var r = q(this);
    U(arguments.length, 2), M(r.entries, {
      key: j(e),
      value: j(t)
    }), !i && this.length++, r.updateURL();
  },
  delete: function _delete(e) {
    for (var t = q(this), r = U(arguments.length, 1), n = t.entries, s = j(e), o = r < 2 ? void 0 : arguments[1], a = void 0 === o ? o : j(o), l = 0; l < n.length;) {
      var u = n[l];
      if (u.key === s && (void 0 === a || u.value === a)) {
        if (W(n, l, 1), void 0 !== a) break;
      } else l++;
    }
    i || (this.size = n.length), t.updateURL();
  },
  get: function get(e) {
    var t = q(this).entries;
    U(arguments.length, 1);
    for (var r = j(e), n = 0; n < t.length; n++) if (t[n].key === r) return t[n].value;
    return null;
  },
  getAll: function getAll(e) {
    var t = q(this).entries;
    U(arguments.length, 1);
    for (var r = j(e), n = [], i = 0; i < t.length; i++) t[i].key === r && M(n, t[i].value);
    return n;
  },
  has: function has(e) {
    for (var t = q(this).entries, r = U(arguments.length, 1), n = j(e), i = r < 2 ? void 0 : arguments[1], s = void 0 === i ? i : j(i), o = 0; o < t.length;) {
      var a = t[o++];
      if (a.key === n && (void 0 === s || a.value === s)) return !0;
    }
    return !1;
  },
  set: function set(e, t) {
    var r,
      n = q(this);
    U(arguments.length, 1);
    for (var s = n.entries, o = !1, a = j(e), l = j(t), u = 0; u < s.length; u++) (r = s[u]).key === a && (o ? W(s, u--, 1) : (o = !0, r.value = l));
    o || M(s, {
      key: a,
      value: l
    }), i || (this.size = s.length), n.updateURL();
  },
  sort: function sort() {
    var e = q(this);
    L(e.entries, function (e, t) {
      return e.key > t.key ? 1 : -1;
    }), e.updateURL();
  },
  forEach: function forEach(e) {
    for (var t, r = q(this).entries, n = v(e, arguments.length > 1 ? arguments[1] : void 0), i = 0; i < r.length;) n((t = r[i++]).value, t.key, this);
  },
  keys: function keys() {
    return new eo(this, "keys");
  },
  values: function values() {
    return new eo(this, "values");
  },
  entries: function entries() {
    return new eo(this, "entries");
  }
}, {
  enumerable: !0
}), o(eu, S, eu.entries, {
  name: "entries"
}), o(eu, "toString", function () {
  return q(this).serialize();
}, {
  enumerable: !0
}), i && a(eu, "size", {
  get: function get() {
    return q(this).entries.length;
  },
  configurable: !0,
  enumerable: !0
}), u(el, z), e({
  global: !0,
  constructor: !0,
  forced: !s
}, {
  URLSearchParams: el
}), !s && p(_)) {
  var ef = n(G.has),
    ec = n(G.set),
    eh = function eh(e) {
      if (y(e)) {
        var t,
          r = e.body;
        if (d(r) === z) return ef(t = e.headers ? new _(e.headers) : new _(), "content-type") || ec(t, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), b(e, {
          body: k(0, j(r)),
          headers: k(0, t)
        });
      }
      return e;
    };
  if (p(F) && e({
    global: !0,
    enumerable: !0,
    dontCallGetSet: !0,
    forced: !0
  }, {
    fetch: function fetch(e) {
      return F(e, arguments.length > 1 ? eh(arguments[1]) : {});
    }
  }), p(Q)) {
    var ep = function ep(e) {
      return h(this, A), new Q(e, arguments.length > 1 ? eh(arguments[1]) : {});
    };
    A.constructor = ep, ep.prototype = A, e({
      global: !0,
      constructor: !0,
      dontCallGetSet: !0,
      forced: !0
    }, {
      Request: ep
    });
  }
}
var em = {
  URLSearchParams: el,
  getState: q
};
export { em as w };